import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    backgroundColor: theme.palette.whitePepper.main,
    height: '80vh',
    width: '100vw',
    overflowY: 'auto',
    overflowX: 'hidden',

    [theme.breakpoints.up('sm')]: {
      width: '480px',
      height: '80vh',
    },

    [theme.breakpoints.up('md')]: {
      width: '600px',
    },
  },

  closeIcon: {
    position: 'absolute',
    top: '25px',
    right: '30px',
    color: theme.palette.turmeric.main,
    zIndex: 10,
    transform: 'scale(1.7)',
    cursor: 'pointer',
  },

  carouselContainer: {},

  categoryImgWrapper: {
    position: 'relative',
    width: '100%',
    height: '250px',
    [theme.breakpoints.up('md')]: {
      height: '265px',
    },
  },

  contentWrapper: {
    position: 'relative',
    padding: '25px',
    [theme.breakpoints.up('md')]: {
      padding: '30px 50px 60px',
    },
  },

  addToCartBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  imgSpiceLevelSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    columnGap: '30px',
  },

  dishImgWrapper: {
    flexShrink: 0,
    position: 'relative',
    width: '100px',
    height: '100px',
    [theme.breakpoints.up('md')]: {
      width: '150px',
      height: '150px',
    },
  },

  symbolWrapper: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
});
